module.exports = __webpack_public_path__ + "img/62.5f45a49b.png";